import {
  RoomModel,
  ProgramModel,
  ProjectModel,
  CategoryModel,
  DepartmentModel,
  RoomContentModel,
  CatalogConstants
} from "@app/catalog";

import {
  BreadcrumbChangedMessage,
  BreadcrumbItemToggleMessage,
  IBreadcrumbItemModel,
  Messenger,
} from "@app/shared";
import { CatalogStateService } from "../services";
import {
  SelectCategoryMessage,
  SelectDepartmentMessage,
  SelectProgramMessage,
  SelectProjectMessage,
  SelectRoomMessage,
} from "@app/catalog-common";
import { CommonConstants } from "@app/app-common";

export class CatalogFilterStateHandler {
  private catalogStateService: CatalogStateService;
  private currentBreadcrumbFilters: IBreadcrumbItemModel[] = [];

  public initialize(
    catalogStateService: CatalogStateService,
    messenger: Messenger,
  ) {
    this.catalogStateService = catalogStateService;

    messenger.subscribe(
      catalogStateService,
      BreadcrumbChangedMessage,
      (message: BreadcrumbChangedMessage) => {
        if(message.breadcrumbName !== CommonConstants.CATALOG) return;
        this.currentBreadcrumbFilters = message.breadcrumbs;
        this.applyBreadcrumbFilter(true);
      },
    );

    messenger.subscribe(
      catalogStateService,
      SelectProgramMessage,
      (message: SelectProgramMessage) => {
        if (message.selected) {
          messenger.send(new BreadcrumbItemToggleMessage(message.selected, CommonConstants.CATALOG));
        }
      },
    );

    messenger.subscribe(
      catalogStateService,
      SelectProjectMessage,
      (message: SelectProjectMessage) => {
        messenger.send(new BreadcrumbItemToggleMessage(message.selected, CommonConstants.CATALOG));
      },
    );

    messenger.subscribe(
      catalogStateService,
      SelectCategoryMessage,
      (message: SelectCategoryMessage) => {
        if (message.selected) {
          messenger.send(new BreadcrumbItemToggleMessage(message.selected, CommonConstants.CATALOG));
        }
      },
    );

    messenger.subscribe(
      catalogStateService,
      SelectDepartmentMessage,
      (message: SelectDepartmentMessage) => {
        if (message.selected) {
          messenger.send(new BreadcrumbItemToggleMessage(message.selected, CommonConstants.CATALOG));
        }
      },
    );

    messenger.subscribe(
      catalogStateService,
      SelectRoomMessage,
      (message: SelectRoomMessage) => {
        if (message.selected) {
          messenger.send(new BreadcrumbItemToggleMessage(message.selected, CommonConstants.CATALOG));
        }
      },
    );
  }

  private applyBreadcrumbFilter(allowReset: boolean = false) {
    const roomId = this.currentBreadcrumbFilters
      .filter((b) => b instanceof RoomModel)
      .map((b) => b as RoomModel)
      .map((r) => r.id)[0];
    const departmentId = this.currentBreadcrumbFilters
      .filter((b) => b instanceof DepartmentModel)
      .map((b) => b as DepartmentModel)
      .map((r) => r.id)[0];
    const programId = this.currentBreadcrumbFilters
      .filter((b) => b instanceof ProgramModel)
      .map((b) => b as ProgramModel)
      .map((r) => r.id)[0];
    const projectId = this.currentBreadcrumbFilters
      .filter((b) => b instanceof ProjectModel)
      .map((b) => b as ProjectModel)
      .map((r) => r.id)[0];
    const roomContentId = this.currentBreadcrumbFilters
      .filter((b) => b instanceof RoomContentModel)
      .map((b) => b as RoomContentModel)
      .map((r) => r.id)[0];
    const categoryId = this.currentBreadcrumbFilters
      .filter((b) => b instanceof CategoryModel)
      .map((b) => b as CategoryModel)
      .map((r) => r.id)[0];

    this.catalogStateService.loadCarousels({
      roomId,
      departmentId,
      programId,
      projectId,
      roomContentId,
      categoryId,
    });
  }
}
